module.exports = __webpack_public_path__ + "img/address.bcb12f4b.svg";